var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card-text",
    [
      _c(
        "v-form",
        { ref: "form", attrs: { id: "login_form", name: "login_form" } },
        [
          _c("v-text-field", {
            attrs: {
              id: "username_field",
              "error-messages": _vm.requiredFieldError(
                _vm.$v.username,
                "Username"
              ),
              name: "username",
              label: "Username",
              "prepend-icon": "mdi-account",
              type: "text",
              required: "",
              "data-cy": "ldapusername",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.$refs.password.focus.apply(null, arguments)
              },
              blur: function ($event) {
                return _vm.$v.username.$touch()
              },
            },
            model: {
              value: _vm.username,
              callback: function ($$v) {
                _vm.username = $$v
              },
              expression: "username",
            },
          }),
          _c("v-text-field", {
            ref: "password",
            attrs: {
              id: "password_field",
              "error-messages": _vm.requiredFieldError(
                _vm.$v.password,
                "Password"
              ),
              type: "password",
              name: "password",
              label: "Password",
              "data-cy": "ldappassword",
              "prepend-icon": "mdi-lock",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.ldapLogin()
              },
              blur: function ($event) {
                return _vm.$v.password.$touch()
              },
            },
            model: {
              value: _vm.password,
              callback: function ($$v) {
                _vm.password = $$v
              },
              expression: "password",
            },
          }),
          _c(
            "v-btn",
            {
              attrs: {
                id: "login_button",
                depressed: "",
                large: "",
                "data-cy": "ldapLoginButton",
                color: "primary",
              },
              on: {
                click: function ($event) {
                  return _vm.ldapLogin()
                },
              },
            },
            [_vm._v(" Login ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }